import React, { useEffect, useState } from 'react';
import { Button, TextField, Link, Typography, Divider } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/styles';
import { Redirect } from 'react-router-dom';
import { RoutesDictionary, RoutesEnum } from '../../../models/routes';
import { ILogin } from '../../../models/login';
// import 'clientjs';
import Grid from '@material-ui/core/Grid';
// // "this library was built to include directly into the browser, not imported."
// // @ts-ignore
// const client = new ClientJS();
import FingerprintJS from '@fingerprintjs/fingerprintjs-pro';
import { PlayerSocketServiceClient } from '../../../shared/services/socket-service';
import { SocketRooms } from '../../../enum/socket/socket-enum';
import { SocketBasicMessageAdmin } from '../../../models/Socket/socket-request';
import { DialogSocketMessagesComponent } from '../../../shared/app-root/dialogs/dialog-socket-messages.component';
import AuthLayout from '../auth-layout';

export interface ExternalProps {
  isLoading: boolean;
  isLoggedIn: boolean;
  loggedInUser: any;
  error?: string;
  query?: any;
}
export interface ExternalActionProps {
  loginAction: (login: ILogin) => void;
  impersonatePlayerAction: (token: string) => void;
}

export interface InternalProps {
  classes: any;
}

function LoginPageComp(
  props: InternalProps & ExternalProps & ExternalActionProps,
): React.ReactElement<InternalProps & ExternalProps & ExternalActionProps> {
  const { classes, isLoggedIn, query, loginAction, impersonatePlayerAction, isLoading } = props;
  const [open, setOpen] = useState<boolean>(false);
  const [request, setRequest] = useState<SocketBasicMessageAdmin | null>(null);
  const [login, setLogin] = React.useState<ILogin>({
    username: '',
    password: '',
    ip: '',
    fingerprint: '',
  });

  useEffect(() => {
    const notificationLoginPage = setTimeout(() => {
      // setRequest({
      //   action: SocketMessageEnum.SHOWDIALOG,
      //   id: '',
      //   message: 'Thanks for choosing VIPClub! Le us know if you need assistance or have any questions.',
      //   room: '',
      //   chat_message: "I'm having problems on the login page, Can you help me?",
      //   showOpenDialogButton: true,
      // });

      PlayerSocketServiceClient({ accessToken: '', userID: SocketRooms.VIPPUBLIC }).StagnantPlayer({
        date: new Date(),
        message: 'Sitting Player on Login.',
        page: window.location.href,
      });
      // setOpen(true);
    }, 60000);
    return () => {
      clearTimeout(notificationLoginPage);
    };
  }, []);

  const [loading, setLoading] = React.useState<boolean>(false);

  const handlerLogin = () => {
    setLoading(true);

    FingerprintJS.load({ token: 'nvoiB2OqFxGoBIg53MC6' })
      .then(fp => fp.get())
      .then(result => {
        const loginRequest = { ...login, fingerprint: result.visitorId };
        loginAction(loginRequest);
        localStorage.setItem('fpjs', result.visitorId);
      })
      .catch(ex => {
        console.log(ex);
        const userId = btoa(login.username + ':login:' + new Date().getTime());
        const loginRequest = { ...login, fingerprint: userId };
        loginAction(loginRequest);
        localStorage.setItem('fpjs', userId);
      });
  };

  useEffect(() => {
    if (isLoading != loading) setLoading(isLoading);
  }, [isLoading]);

  const setUsername = (username: string) => {
    setLogin({ ...login, username });
  };

  const setPassword = (password: string) => {
    setLogin({ ...login, password });
  };

  const setLoginIp = (ip: string) => {
    setLogin({ ...login, ip });
  };

  useEffect(() => {
    if (query && query.imp) {
      impersonatePlayerAction(query.imp);
    }
  }, [query]);

  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then(response => {
        return response.json();
      })
      .then(res => {
        setLoginIp(res.ip);
      })
      .catch(err => console.error('Problem fetching my IP', err));
  }, []);

  const startChat = (w: any, d: any, u: any) => {
    const s = d.createElement('script');
    s.setAttribute('id', 'liveChat');
    s.async = true;
    s.src = u + '?' + Date.now() / 60000;
    const h = d.getElementsByTagName('script')[0];
    h.parentNode.insertBefore(s, h);
  };

  useEffect(() => {
    startChat(window, document, 'https://ymt.pdub.lv/upload/crm/site_button/loader_1_wc8kwi.js');
  }, []);

  const handlerDialog = () => {
    setRequest(null);
    setOpen(false);
  };

  if (isLoggedIn) {
    return <Redirect to={'/sportsbook'} />;
  }

  return (
    <AuthLayout isLoading={isLoading}>
      {request && open && <DialogSocketMessagesComponent handlerDialog={handlerDialog} setOpen={setOpen} open={open} request={request} />}

      <div className={classes.form}>
        {/* <Alert severity='warning'>
              <AlertTitle>Attention</AlertTitle>
              We will be down for maintenance from 6 AM to 2PM PST. Thank you for understanding
              <br /> <br />- VIP Team
            </Alert> */}
        <form
          noValidate
          onSubmit={event => {
            event.preventDefault();
            handlerLogin();
          }}
        >
          <TextField
            id='username'
            variant='filled'
            margin='normal'
            required
            fullWidth
            label='Username or Email'
            value={login.username}
            onChange={event => setUsername(event.target.value)}
            autoFocus
            className={classes.inputText}
          />
          <TextField
            id='password'
            variant='filled'
            margin='normal'
            required
            fullWidth
            label='Password'
            type='password'
            value={login.password}
            onChange={event => setPassword(event.target.value)}
            className={classes.inputText}
          />

          <Grid container justify='space-between' style={{ marginBottom: '.5rem' }}>
            <Link className={classes.moveForgotUsernameToLeft} href='https://agents.vipclub.lv/' target='_blank'>
              Affiliate Login
            </Link>
            <Link className={classes.moveForgetPasswordToRight} href={`#${RoutesDictionary[RoutesEnum.ForgetPassword].path}`}>
              Forgot Password?
            </Link>
          </Grid>

          <Button variant='contained' color='primary' type='submit' disabled={loading || !login.username || !login.password} fullWidth>
            <Typography variant='button'>{loading ? 'logging In...' : 'LogIn'}</Typography>
          </Button>

          <Grid
            container
            alignItems='center'
            style={{
              marginTop: '1rem',
              marginBottom: '1rem',
            }}
          >
            <Grid item xs>
              <Divider />
            </Grid>
            <Grid item>
              <Typography style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>or</Typography>
            </Grid>
            <Grid item xs>
              <Divider />
            </Grid>
          </Grid>

          <Button
            color='default'
            variant='contained'
            onClick={() => {
              window.open(process.env.PUBLIC_URL + '/#/signup/VIPBB', '_self');
            }}
            style={{ marginRight: '1rem' }}
            disabled={loading}
            fullWidth
          >
            JOIN NOW
          </Button>
        </form>
      </div>
    </AuthLayout>
  );
}

const styles: any = createStyles({
  form: {
    padding: 0,
  },
  moveForgetPasswordToRight: {
    paddingTop: 20,
    paddingBottom: 10,
    fontSize: '16px',
  },
  moveForgotUsernameToLeft: {
    paddingTop: 20,
    paddingBottom: 10,
    color: 'white',
    fontSize: '16px',
  },
  inputText: {
    marginBottom: '.5rem',
    marginTop: '1rem',
  },
});

export const LoginPage = withStyles(styles)(LoginPageComp);
